// extracted by mini-css-extract-plugin
export default {"responsive_grid":"CreateSection_responsive_grid__9p+nu"};